<template>
  <div id="portraits" class="section">
    <v-container>
      <h1>Workshops and Portrait Demonstrations</h1>

      <v-layout row wrap>
        <v-flex xs12 sm3 pl-4>
              <a data-fancybox="gallery" data-type="image" href="/img/portrets/port-watercolor.png">
                <div class="img-thumbnail">
                  <img src="/img/portrets/port-watercolor_thumb.png" alt="Образец работы" class="img-fluid">              
                </div>
              </a>
        </v-flex>
        <v-flex xs12 sm6 pl-4>
          <p class="text-justify">
            Many people interested in painting portraits are put off by the seeming complexity of the process. Whilst it is a complex set of skills required to create a picture with a good likeness of the subject, they can be mastered step by step.
          </p>
          <p class="text-justify">
            Maria has run successful private workshops and portrait demonstrations for groups ranging from 2 to 20 artists, breaking down the process as she paints.
          </p>
          <p class="text-justify">
              The first thing you must do” Maria explains, “is not just look, but really see. Really observe the subject as they are, not as you think they are or expect them to be. Beyond that are issues related to proportion, perspective and colour which, once explained, can only be fully understood and developed through practice.
          </p>
          <p class="text-justify">
              An Alla Prima portrait demonstration (a painting done in one sitting) takes approximately two hours, and is a great way of going through the basic stages of a painting. Alternatively why not book a tutored workshop with model for a full day or half day, and enjoy drawing or painting with all your questions answered as they arise?
          </p>  
        </v-flex>
        <v-flex xs12 sm3 pl-4>
            <a data-fancybox="gallery" data-type="image" href="/img/portrets/port-katiataylor.png">
              <div class="img-thumbnail">
                <img src="/img/portrets/port-katiataylor_thumb.png" alt="Образец работы" class="img-fluid">              
              </div>
            </a>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  export default {
    name: 'Portraits',
      data: ()=>({

      })
  }
</script>

<style>
  #portraits .img-left {
    float: left;
    padding: 0 5px;
    border-right: 1px solid #232323;
    border-bottom: 1px solid #232323;
    margin-right: 15px;
  }

  #portraits .img-right {
    float: right;
    padding: 0 5px;
    border-left: 1px solid #232323;
    border-bottom: 1px solid #232323;
    margin-left: 15px;
  }
  #portraits .text {
    margin-bottom: 50px!important;
  }
  #portraits .img-thumbnail {
    padding: 5px;
    border: 1px solid #ccc;
    float: left;
    border-radius: 5px;
  }
</style>